<script lang="ts">
  import { getContext } from 'svelte';
  import { page } from '$app/stores';
  import { sendEvent } from './helpers/GoogleAnalytics';
  import { Link, Heading, Paragraph, Wrapper } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;

  const lpKey = getContext('lpKey');
  const country = getContext('country');
  const hash = getContext('hash');

  $: phoneGTM = {
    cta_text: properties?.button?.label,
    user_domain: $page.url.hostname,
    lpKey: lpKey,
    section_clicked: 'banner',
    set_country: country,
    phone_number: properties?.destination?.link,
  };
</script>

{#if properties}
  <Wrapper style="background:var(--vlt-lp-primary);" classes={'p-sm'}>
    <div
      class="banner-container"
      id={properties?.anchor}
      style="color:var(--vlt-lp-primary-text);"
    >
      <div class="overlay-bg">
        <div class="content" style="text-align: {properties.alignment}">
          <div class="text">
            <Link
              url={properties.destination.link}
              type={properties.destination.link_type}
              {phoneGTM}
            >
              {#if properties.destination.link_type === 'Phone'}
                <div class="icon-link">
                  <div>
                    <Heading type={'h2'} css="color:var(--vlt-lp-primary-text);"
                      ><span class="heading-wrapper"
                        >{@html properties.destination.label}</span
                      ></Heading
                    >
                    {#if properties.text}
                      <a
                        href="tel:{properties.destination}"
                        on:click={ev => {
                          if (country) {
                            sendEvent(`${country}_Click_To_Call`, {
                              hash,
                            });
                          }
                        }}
                      >
                        <Paragraph css="color:var(--vlt-lp-primary-text);"
                          >{@html properties.text}</Paragraph
                        >
                      </a>
                    {/if}
                  </div>
                </div>
              {:else if properties.destination.link_type === 'Email'}
                <div class="icon-link">
                  <div>
                    <Heading type={'h2'} css="color:var(--vlt-lp-primary-text);"
                      >{@html properties.destination.label}
                    </Heading>
                    {#if properties.text}
                      <a href="mailto:{properties.destination}">
                        <Paragraph css="color:var(--vlt-lp-primary-text);"
                          >{@html properties.text}</Paragraph
                        >
                      </a>
                    {/if}
                  </div>
                </div>
              {:else}
                <Heading type={'h2'} css="color:var(--vlt-lp-primary-text);"
                  >{@html properties.destination.label}
                </Heading>
                {#if properties.text}
                  <Paragraph css="color:var(--vlt-lp-primary-text);"
                    >{@html properties.text}</Paragraph
                  >
                {/if}
              {/if}
            </Link>

            {#if properties.text}
              <Paragraph css="color:var(--vlt-lp-primary-text);"
                >{@html properties.text}</Paragraph
              >
            {/if}
          </div>
        </div>
      </div>
    </div>
  </Wrapper>
{/if}

<style>
  .banner-container {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }

  .text {
    display: inline-flex;
    align-items: center;
    text-align: center;
    grid-gap: 10px;
  }
  .icon-link {
    display: flex;
  }

  @media screen and (max-width: 900px) {
    .text {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    .text {
      padding-left: 20px;
      padding-right: 20px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .heading-wrapper {
      font-size: 0.8em;
    }

    .overlay-bg {
      padding: 25px 0px;
    }
  }
</style>
